module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-10.d0413660.png";